export const CardType = {
    now: "now",
    upcoming: "upcoming",
    past: "past",

} as const;

export type CardType = typeof CardType[keyof typeof CardType];